export const root = "rj4qfhw";
export const detail = "d1c905fs";
export const row = "r5jmkvr";
export const info = "i218fga";
export const title = "t1bbma54";
export const icon = "i1lr9tdd";
export const recommendedTag = "r1sez8do";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");